import { Application } from "@hotwired/stimulus"

// Instead of starting a new application, look for an existing one
// or create a new one if not found
const application = window.Stimulus || Application.start()

// Configure Stimulus development experience
application.debug = true;
window.Stimulus = application;

export { application }